<div class="notifications round-panel" [ngClass]="{ disabled: disabled }" [formGroup]="notifyForm">
  <table>
    <tr>
      <th>
        <b>{{ 'estate.notifyEnd' | locCap }}:</b>
      </th>
      <th *ngFor="let n of ESTATE_NOTIFY_DAYS">{{ n }}</th>
    </tr>
    <tr *ngFor="let formName of notifyKeys" [formGroup]="$any(notifyForm.controls[formName])">
      <td>{{ 'estate.' + formName + 'End' | locCap }}</td>
      <td *ngFor="let n of ESTATE_NOTIFY_DAYS">
        <app-checkbox-input [formControlName]="n" [disabled]="disabled"></app-checkbox-input>
      </td>
    </tr>
  </table>
</div>

